export const roles = {
    beekeeper: {
        name: 'beekeeper',
        app_name: 'beekeepers',
        url: process.env.REACT_APP_BEEHERO_BEEKEEPERS,
        color: 'yellow'
    },
    farmer: {
        name: 'farmer',
        app_name: 'growers',
        url: process.env.REACT_APP_BEEHERO_GROWERS,
        color: 'dark-green'
    },
    demo_grower: {
        name: 'demo_grower',
        app_name: 'growers',
        url: process.env.REACT_APP_BEEHERO_GROWERS,
        color: 'dark-green'
    },
    admin: {
        name: 'admin',
        app_name: 'admin',
        url: process.env.REACT_APP_BEEHERO_ADMIN,
        color: 'dark-grey'
    },
    admin_v2: {
        name: 'admin_v2',
        app_name: 'Admin v2',
        url: process.env.REACT_APP_BEEHERO_ADMIN_V2,
        color: 'light-green'
    },
    onion_inspector: {
        name: 'onion_inspector',
        app_name: 'admin',
        url: process.env.REACT_APP_BEEHERO_ADMIN,
        color: 'dark-grey'
    },
    pca: {
        name: 'pca',
        app_name: 'growers',
        url: process.env.REACT_APP_BEEHERO_GROWERS,
        color: 'dark-green'
    },
    admin_hardware: {
        name: 'admin_hardware',
        app_name: 'admin',
        url: process.env.REACT_APP_BEEHERO_ADMIN,
        color: 'dark-grey'
    },
    admin_beekeepers: {
        name: 'admin_beekeepers',
        app_name: 'admin',
        url: process.env.REACT_APP_BEEHERO_ADMIN,
        color: 'dark-grey'
    },
    admin_research: {
        name: 'admin_research',
        app_name: 'admin',
        url: process.env.REACT_APP_BEEHERO_ADMIN,
        color: 'dark-grey'
    },
    admin_growers: {
        name: 'admin_growers',
        app_name: 'admin',
        url: process.env.REACT_APP_BEEHERO_ADMIN,
        color: 'dark-grey'
    },
    external: {
        name: 'external',
        app_name: 'beekeepers',
        url: process.env.REACT_APP_BEEHERO_BEEKEEPERS,
        color: 'dark-grey'
    },
    beemover: {
        name: 'beemover',
        app_name: 'beemovers',
        url: process.env.REACT_APP_BEEHERO_BEEMOVERS,
        color: 'blue'
    }
};
